import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ✅ GET: Traer todos los productos
export const getProductos = async () => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/productos`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener productos",
    };
  }
};

// ✅ GET: Traer un producto por ID
export const getProductoById = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/productos/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener producto",
    };
  }
};

// ✅ POST: Crear nuevo producto
export const postProducto = async (productoData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/productos`;

  try {
    const resp = await axios.post(url, productoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear producto",
    };
  }
};

// ✅ PUT: Actualizar producto
export const putProducto = async (id, productoData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/productos/${id}`;

  try {
    const resp = await axios.put(url, productoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar producto",
    };
  }
};

// ✅ DELETE: Desactivar producto
export const deleteProducto = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/productos/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar producto",
    };
  }
};
